import type { ReactNode } from 'react';

export const symbol_files: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M140-160q-24.75 0-42.37-17.63Q80-195.25 80-220v-440q0-24.75 17.63-42.38Q115.25-720 140-720h254l80-80h346q24.75 0 42.38 17.62Q880-764.75 880-740v520q0 24.75-17.62 42.37Q844.75-160 820-160H140Zm59-280h241v-241L199-440Zm-59-26 194-194H140v194Zm0 86v160h680v-520H500v300q0 24.75-17.62 42.37Q464.75-380 440-380H140Zm310-130Z"
		/>
	</svg>
);
